module.exports = __webpack_public_path__ + "a42b27e44a7b5a902387c7f51983c55f.woff";